import { createFeatureSelector } from '@ngrx/store';

export const cartPopupState = createFeatureSelector<OLO.State, OLO.State.CartPopup>('cartPopup');
